import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import arTranslation from '../locales/ar/translation.json';
import enTranslation from '../locales/en/translation.json';

// Translation resources with login page keys
const resources = {
  ar: {translation: arTranslation},
  en: {translation: enTranslation}
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ar',
    fallbackLng: 'ar',
    interpolation: {escapeValue: true}
  });

export default i18n;
